export default __webpack_public_path__ + "media/images/brands/expmessenger/other/about_us-918d44ed1712106bf1265a25851e01a5.jpg";